import { Button, DefaultContent, ErrorCard } from '../components';
import React, { FunctionComponent, useEffect } from 'react';
import { useAuth, useLayout } from '../hooks';
import { useLocation, useNavigate } from 'react-router-dom';

import { LayoutEnum } from '../enums';
import { useTranslation } from 'react-i18next';

const PUBLIC_URL = process.env.PUBLIC_URL;

export const PaginaNaoEncontradaView: FunctionComponent = () => {
  const { t } = useTranslation();
  const { authenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { setLayout } = useLayout();

  useEffect(() => {
    setLayout(LayoutEnum.BASE_LAYOUT);
  }, []);

  return (
    <DefaultContent>
      <ErrorCard>
        <div className="empty-body-card single-card text-center py-2">
          <img className="img-fluid" alt="Página Não Encontrada" src={`${PUBLIC_URL}${'/assets/images/bot_404.png'}`} />
          <h1 className="display-4">{t('label.pagina_nao_encontrada')}</h1>
          <p
            className="lead"
            dangerouslySetInnerHTML={{ __html: t('texto.pagina_nao_encontrada', { path: location.pathname }) }}
          />
          <Button
            className="mt-3"
            title={t('label.pagina_inicial')}
            onClick={() => {
              navigate(authenticated ? '/eleicoes' : '/');
            }}
          />
        </div>
      </ErrorCard>
    </DefaultContent>
  );
};
